import TableSkeleton from "../../../common-components/TableSkeleton";
import PaginationBar from "./PaginationBar";

const Table = ({
  columns,
  data = [],
  isPage,
  setIsPage,
  paginationArray,
  pageLimit,
  setPageLimit,
  isLoading,
}) => {
  return (
    <>
      <PaginationBar
        isPage={isPage}
        setIsPage={setIsPage}
        paginationArray={paginationArray}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
      />

      {isLoading ? (
        <>
          <TableSkeleton columns={12} rows={20} />

          {/* <div className="lead-v2-cycle-loading">
            <div className="lead-v2-loading-spinner"></div>
            <p>Loading leads...</p>
          </div> */}
        </>
      ) : (
        <>
          <div className="custom-table-wrapper">
            <table className="custom-table">
              <thead>
                <tr>
                  {columns.map((col, idx) => (
                    <th key={col.key || idx} className="custom-th">
                      {col.header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data?.length === 0 ? (
                  <tr>
                    <td colSpan={columns.length} className="custom-table-empty">
                      No data found.
                    </td>
                  </tr>
                ) : (
                  data.map((row, rowIdx) => (
                    <tr
                      key={row.id || row.lead_id || rowIdx}
                      className="custom-table-row"
                    >
                      {columns.map((col, colIdx) => (
                        <td key={col.key || colIdx} className="custom-td">
                          {col.render ? col.render(row) : row[col.key]}
                        </td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>{" "}
        </>
      )}
    </>
  );
};

export default Table;
